import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

export const filterPinnedFields = (field: IField) =>
  !field.hasFeature(FieldFeature.MAP_PINNED_FIELD) && field.isReadable;
